module.exports = __webpack_public_path__ + "static/image-portfolio-3016a59de9abfa0b6369ec57d8e5a152.jpg";